// What the query builders share (Explore › Metrics and Traces, APS-198; Logs, APS-327): the
// ranges in milliseconds, a query bar's mistakes and a run's refusals, in the reader's words.
import { isApiError } from '../api/client'
import type { Translator } from '../i18n'
import type { LogQueryError } from '../lib/logQuery'
import type { ExploreRange } from './search'

export const RANGE_MS: Record<ExploreRange, number> = {
  '1h': 3_600_000,
  '24h': 86_400_000,
  '7d': 7 * 86_400_000,
  '30d': 30 * 86_400_000,
}

export function queryErrorText(t: Translator['t'], error: LogQueryError): string {
  switch (error.code) {
    case 'quote':
      return t('explore.logs.err.quote', { position: error.position })
    case 'severity':
      return t('explore.logs.err.severity', { value: error.value, position: error.position })
    case 'field':
      return t('explore.logs.err.field', { value: error.value, position: error.position })
    case 'empty':
      return t('explore.logs.err.empty', { value: error.value, position: error.position })
    case 'tooMany':
      return t('explore.logs.err.tooMany')
    default:
      return t('explore.logs.err.tooLong')
  }
}

export function runError(t: Translator['t'], error: unknown): string {
  if (isApiError(error, 429)) return t('explore.logs.err.rate')
  if (isApiError(error, 400)) return t('explore.logs.err.invalid')
  if (isApiError(error, 422) || isApiError(error, 503)) return t('explore.logs.err.limit')
  return t('state.failed')
}
